export enum AsnLevel {
    OrderLevel,
    BarcodeLevel
}

export enum AsnType {
    CSV,
    XLS,
    XLSX
}